import styled from 'styled-components';

export const PageSection = styled.section`
  padding: 0.1rem 2rem 6rem;
  background-color: ${props => props.bgColor || 'white'};
  
  &:first-of-type {
    padding-top: 0.1rem;
  }
`;

export const SectionContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: #333;
  font-weight: 600;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

// STANDARD BUTTON - ALL BUTTONS MUST USE THIS EXACT STYLING FROM HOME PAGE
const BaseButtonStyles = `
  display: inline-block;
  padding: 0.8rem 1.5rem;
  border-radius: 5px;
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
  
  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    font-size: 0.75rem;
  }
`;

// White button - black text (for Home page)
export const WhiteButton = styled.a`
  ${BaseButtonStyles}
  background-color: white;
  color: black;
  
  &:hover {
    background-color: #f8f8f8;
  }
`;

// Orange button - black text
export const OrangeButton = styled.a`
  ${BaseButtonStyles}
  background-color: #FF8C00;
  color: black;
  
  &:hover {
    background-color: #FF7700;
  }
`;

// Grey button - white text
export const GreyButton = styled.a`
  ${BaseButtonStyles}
  background-color: #666;
  color: white;
  
  &:hover {
    background-color: #555;
  }
`;

// Black button (for forms) - white text
export const BlackButton = styled.button`
  ${BaseButtonStyles}
  background-color: #000;
  color: white;
  
  &:hover {
    background-color: #222;
  }
`;

// Black button link - white text
export const BlackButtonLink = styled.a`
  ${BaseButtonStyles}
  background-color: #000;
  color: white;
  
  &:hover {
    background-color: #222;
  }
`;

// Legacy support
export const CTAButton = styled.a`
  ${BaseButtonStyles}
  background-color: #FF8C00;
  color: black;
  
  &:hover {
    background-color: #FF7700;
  }
`;

export const TealButton = styled.a`
  ${BaseButtonStyles}
  background-color: #666;
  color: white;
  
  &:hover {
    background-color: #555;
  }
`;

